import { render, staticRenderFns } from "./completion_payment.vue?vue&type=template&id=e6b56e2e&scoped=true&"
import script from "./completion_payment.vue?vue&type=script&lang=js&"
export * from "./completion_payment.vue?vue&type=script&lang=js&"
import style0 from "./completion_payment.vue?vue&type=style&index=0&id=e6b56e2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b56e2e",
  null
  
)

export default component.exports